import { addDays } from 'date-fns';
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';
import { writable } from 'svelte/store';
const JWT_COOKIE_KEY = 'access_token';
const createLoginUserStore = () => {
    const { subscribe, set } = writable(null);
    return {
        subscribe,
        loginFromCookie: () => {
            const cookieToken = Cookies.get(JWT_COOKIE_KEY);
            if (cookieToken) {
                const decodeLoginUser = jwtDecode(cookieToken);
                set({
                    loginUserInfoId: decodeLoginUser.login_user_info_id,
                    accountId: decodeLoginUser.account_id,
                    loginId: decodeLoginUser.login_id,
                    token: cookieToken,
                    businessCode: decodeLoginUser.business_code,
                    sei: decodeLoginUser.sei,
                    mei: decodeLoginUser.mei,
                    email: decodeLoginUser.email
                });
            }
        },
        logout: () => {
            Cookies.remove(JWT_COOKIE_KEY);
            set(null);
        }
    };
};
// 現在ログイン中のユーザー
export const loginUser = createLoginUserStore();
// JWTトークンを保存する
// cookieの有効期限は
export const saveJwt = (jwt) => {
    const expires = addDays(new Date(), 1);
    Cookies.set(JWT_COOKIE_KEY, jwt, {
        expires: expires
    });
    loginUser.loginFromCookie();
};
